// extracted by mini-css-extract-plugin
export default {"background":"ForgotPW_background__pK-MD","plane":"ForgotPW_plane__ZiebO","fly":"ForgotPW_fly__Vkpqc","icon":"ForgotPW_icon__Ob5TG"};